/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

const THEME_KEY = 'diobuch_theme';
const LIGHT = 'light';
const DARK = 'dark';

function getInitialTheme() {
  if (typeof window === 'undefined') {
    return LIGHT;
  }

  const stored = window.localStorage.getItem(THEME_KEY);
  if (stored === LIGHT || stored === DARK) {
    return stored;
  }

  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return DARK;
  }

  return LIGHT;
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const root = document.documentElement;
    root.classList.remove(`theme-${LIGHT}`, `theme-${DARK}`);
    root.classList.add(`theme-${theme}`);

    try {
      window.localStorage.setItem(THEME_KEY, theme);
    } catch {
      // ignore storage errors
    }
  }, [theme]);

  function toggleTheme() {
    setTheme((prev) => (prev === DARK ? LIGHT : DARK));
  }

  function setThemeById(nextTheme) {
    if (nextTheme === LIGHT || nextTheme === DARK) {
      setTheme(nextTheme);
    }
  }

  const value = { theme, toggleTheme, setTheme: setThemeById };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
}

export default ThemeContext;

